// extracted by mini-css-extract-plugin
module.exports = {"topic":"Topic_topic__ST0xZ","skeletonPill":"Topic_skeletonPill__3gk5p"};